import { useQuery } from '@tanstack/react-query';
import api from '../lib/axios';

// SEO-Checkliste (Cockpit) je Projekt — Axios hängt ?project automatisch an.
export function useSeoChecklist(projectId) {
  return useQuery({
    queryKey: ['seo-checklist', projectId],
    enabled: !!projectId,
    queryFn: async () => (await api.get('/seo-checklist')).data,
  });
}

// Maßnahmen (Arbeitsschlange) je Projekt.
export function useSeoMeasures(projectId) {
  return useQuery({
    queryKey: ['seo-measures', projectId],
    enabled: !!projectId,
    queryFn: async () => (await api.get('/seo-measures')).data,
  });
}
